import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import {
    Form,
    FormAnswers,
    FormQuestion,
    FormQuestionAnswer,
    FormQuestionAnswers,
    uuid,
    ValueType,
} from "./FeedbackFormModel";

export function getDummyFeedbackForm(): Promise<Form> {
    return new Promise<Form>(
        (res) => {
            res(exampleForm);
        },
    );
}

export function dummySubmitFormAnswers(formTypeGuid: uuid, entityGuid: uuid, answers: FormAnswers): Promise<void> {
    return new Promise<void>((res) => res());
}

export function getFeedbackForm(formTypeGuid: uuid, entityGuid: uuid): Promise<Form> {
    return new Promise<Form>((res, rej) => {
        RestDataLoader.loadData(
            "forms/" + formTypeGuid + "/entity/" + entityGuid,
            {},
            (data) => res(data),
            () => rej(),
        );
    });
}

export function getFeedbackForms(formTypeGuid: uuid, entitiesGuid: uuid[]): Promise<Form[]> {
    return new Promise<Form[]>((res, rej) => {
        RestDataLoader.loadData(
            "forms?typeGuid=" + formTypeGuid + "&"
            + entitiesGuid.reduce((result, entityGuid) => {
                return result + "&entityGuids=" + entityGuid;
            }, ""),
            {},
            (data) => res(data.list as Form[]),
            () => rej(),
        );
    });
}

export function isValidFormAnswers(form: Form, answers: FormAnswers): boolean {
    return form.questions.reduce((a, question) => {

        if (!shouldQuestionBeVisible(question, answers.questions)) {
            return a;
        }

        const answer = answers.questions.find((x) => x.questionGuid === question.guid);

        if (!answer) {
            return a && !question.required;
        }

        const emptyTextNumberValue = answer.value.reduce((empty, val) => {
            return empty || (("" + val).trim() === "");
        }, false);

        return a && ((answer.value.length > 0 && !emptyTextNumberValue) || !question.required);
    }, true);
}

export function submitFormAnswers(formTypeGuid: uuid, entityGuid: uuid, answers: FormAnswers): Promise<void> {
    return new Promise<void>((res, rej) => {
        RestDataLoader.putJSON(
            "forms/" + formTypeGuid + "/entity/" + entityGuid + "/answers",
            {
                list: answers.questions,
            },
            () => res(),
            () => rej(),
        );
    });
}

export function shouldQuestionBeVisible(entity: FormQuestion, formAnswers: FormQuestionAnswer[]): boolean {
    if (!entity.questionDependencies || entity.questionDependencies.length === 0) {
        return true;
    }

    return entity.questionDependencies.reduce((result, dependency) => {
        const dependencyAnswer = formAnswers.find((x) =>
            x.questionGuid === dependency.questionMasterGuid,
        );

        if (!dependencyAnswer) {
            return result;
        }

        return result
            || dependencyAnswer.value.findIndex((answer) => answer === dependency.answerValueGuid) > -1;
    }, false);
}

// Puo essere eliminato dopo
const exampleForm: Form = {
    title: "Dummy Feedback",
    // tslint:disable-next-line:max-line-length
    description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut a commodo nunc. Vestibulum in tempor augue, congue sollicitudin neque. Etiam vel ipsum mi. Aenean vestibulum vitae neque vel euismod. Nam eu dui vel nibh ultricies pharetra. Nulla nec ante justo",
    formTypeGuid: "",
    questions: [
        {
            text: "Was the alarm useful?",
            guid: "Was the alarm useful?",
            required: true,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: [
                {
                    defaultValue: false,
                    value: "YES",
                    guid: "YES",
                },
                {
                    defaultValue: false,
                    value: "NO",
                    guid: "NO",
                },
            ],
        },
        {
            text: "Why?",
            guid: "Why wasn't useful?",
            required: false,
            questionTypeGuid: ValueType.TEXTAREA,
            questionDependencies: [
                {
                    questionMasterGuid: "Was the alarm useful?",
                    answerValueGuid: "NO",
                },
            ],
        },
        {
            text: "How long did it take you to fix the problem?",
            guid: "How long did it take you to fix the problem?",
            required: true,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: [
                {
                    defaultValue: false,
                    value: "Ore viaggio",
                    guid: "Ore viaggio",
                },
                {
                    defaultValue: false,
                    value: "Ore lavorate",
                    guid: "Ore lavorate",
                },
            ],
        },
        {
            text: "How many spare parts did you need?",
            guid: "How many spare parts did you need?",
            required: true,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: [
                {
                    defaultValue: false,
                    value: "None used",
                    guid: "None used",
                },
                {
                    defaultValue: false,
                    value: "Some parts where changed",
                    guid: "Some parts where changed",
                },
                {
                    defaultValue: false,
                    value: "Cabinet was replaced",
                    guid: "Cabinet was replaced",
                },
            ],
        },
        {
            text: "Number of space parts",
            guid: "Number of space parts",
            required: false,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: Array.from({length: 5}).map<FormQuestionAnswers>((_, i) => ({
                defaultValue: false,
                guid: "x" + i,
                value: "" + (i + 1),
            })),
            questionDependencies: [
                {
                    questionMasterGuid: "How many spare parts did you need?",
                    answerValueGuid: "Some parts where changed",
                },
            ],
        },
        {
            text: "How much did it cost?",
            guid: "How much did it cost?",
            required: true,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: [
                {
                    defaultValue: false,
                    value: "0/50€",
                    guid: "0/50€",
                },
                {
                    defaultValue: false,
                    value: "50/100€",
                    guid: "50/100€",
                },
                {
                    defaultValue: false,
                    value: "100€+",
                    guid: "100€+",
                },
            ],
        },
        {
            text: "Was the system able to avoid losing the content?",
            guid: "Was the system able to avoid losing the content?",
            required: true,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: [
                {
                    defaultValue: false,
                    value: "YES",
                    guid: "YES",
                },
                {
                    defaultValue: false,
                    value: "NO",
                    guid: "NO",
                },
            ],
        },
        {
            text: "Did the system notify the problem before the client took notice?",
            guid: "Did the system notify the problem before the client took notice?",
            required: true,
            questionTypeGuid: ValueType.SELECT,
            availableResponseValues: [
                {
                    defaultValue: false,
                    value: "YES",
                    guid: "YES",
                },
                {
                    defaultValue: false,
                    value: "NO",
                    guid: "NO",
                },
            ],
        },
    ],
    entityGuid: "",
    entityInfoList: [
        {
            label: "Type of alarm",
            value: "Unauthorized movement",
        },
        {
            label: "Alarm category",
            value: "Movement",
        },
        {
            label: "Signal date",
            value: "2021/04/21 21:00",
        },
    ],
};
